/**
 * Icones da navegacao da esquerda, embutidos como SVG.
 *
 * Usuarios e Sair nao estao aqui: sairam da sidebar para o painel da conta, e
 * la os icones sao proprios do painel.
 *
 * O sistema legado carregava a Lucide por CDN, o que obrigava a CSP a liberar
 * `unpkg.com` em `script-src`. Embutir os poucos icones usados fecha essa
 * excecao e remove uma dependencia de rede do carregamento da pagina.
 */

const PATHS = {
  home: (
    <>
      <path d="M3 10.5 12 3l9 7.5" />
      <path d="M5.5 9.5V20a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1V9.5" />
      <path d="M9.5 21v-6h5v6" />
    </>
  ),
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />,
  checklist: (
    <>
      <path d="M3 6l2 2 3-3" />
      <path d="M3 14l2 2 3-3" />
      <path d="M12 7h9" />
      <path d="M12 15h9" />
    </>
  ),
  report: (
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M9 13h6" />
      <path d="M9 17h4" />
    </>
  ),
  plano: (
    <>
      <path d="M4 4v14" />
      <path d="M4 4h5M4 11h5M4 18h5" />
      <rect x="9" y="2" width="11" height="4" rx="1" />
      <rect x="9" y="9" width="11" height="4" rx="1" />
      <rect x="9" y="16" width="11" height="4" rx="1" />
    </>
  ),
  planilha: (
    <>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M8.5 12.5h7M8.5 16h7M12 12.5V16" />
    </>
  ),
  lock: (
    <>
      <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
      <path d="M8 10.5V7.8a4 4 0 0 1 8 0v2.7" />
      <path d="M12 14.5v2.5" />
    </>
  ),
  sliders: (
    <>
      <path d="M5 6h14" />
      <path d="M5 12h14" />
      <path d="M5 18h14" />
      <circle cx="9" cy="6" r="2" fill="currentColor" />
      <circle cx="15" cy="12" r="2" fill="currentColor" />
      <circle cx="10" cy="18" r="2" fill="currentColor" />
    </>
  ),
  /* Cofre: o banco visto pelo lado da contabilidade, nao pelo do extrato — por
     isso nao repete a pasta de Extratos. */
  banco: (
    <>
      <path d="M3 9.5 12 4l9 5.5" />
      <path d="M5 10.5v8M9.5 10.5v8M14.5 10.5v8M19 10.5v8" />
      <path d="M3.5 20.5h17" />
    </>
  ),
  /* Balanca: a conta patrimonial existe para equilibrar os dois lados. */
  patrimonio: (
    <>
      <path d="M12 4v16" />
      <path d="M6.5 20.5h11" />
      <path d="M4 8h16" />
      <path d="M7.5 8 4.5 14.5h6z" />
      <path d="M16.5 8l-3 6.5h6z" />
    </>
  ),
  balanco: (
    <>
      <path d="M12 4v16" />
      <path d="M6 8H3l3-4 3 4H6z" />
      <path d="M18 8h-3l3-4 3 4h-3z" />
      <path d="M3 8v3a3 3 0 0 0 6 0V8" />
      <path d="M15 8v3a3 3 0 0 0 6 0V8" />
      <path d="M8 20h8" />
    </>
  ),
  /* Seta saindo da caixa: o dado deixa o sistema. */
  exportar: (
    <>
      <path d="M12 3v11" />
      <path d="m8.5 10.5 3.5 3.5 3.5-3.5" />
      <path d="M4.5 15v3.5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V15" />
    </>
  ),
} as const;

export type IconName = keyof typeof PATHS;

export function NavIcon({ name }: { name: IconName }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  );
}
